'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecentResultsDirective = function () {
  function RecentResultsDirective($state) {
    _classCallCheck(this, RecentResultsDirective);

    this._ = { $state: $state };

    this.showAll = false;
    this.shortlistedNum = 2;
  }

  _createClass(RecentResultsDirective, [{
    key: 'go',
    value: function go(state, params) {
      this._.$state.go(state, params);
    }
  }, {
    key: 'shortlistedMessage',
    value: function shortlistedMessage() {
      return !this.showAll ? 'You are seeing ' + this.shortlistedNum + ' of ' + this.results.length + ' results' : 'You are seeing all ' + this.results.length + ' results';
    }
  }]);

  return RecentResultsDirective;
}();

exports.default = angular.module('ifeis.dashboard-recent-results', []).directive('fRecentResults', function () {
  return {
    bindToController: true,
    controller: 'RecentResultsDirective',
    controllerAs: 'results',
    replace: true,
    scope: {
      results: '='
    },
    template: require('./tpl.html')
  };
}).controller('RecentResultsDirective', RecentResultsDirective);


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/recent-results/index.js
// module id = 528
// module chunks = 0